import { Clock } from "lucide-react";
import { DetailItem } from "@/bizminer/Admin/InsightRequests/_components/DetailItem.tsx";
import { StatusBadge } from "@/bizminer/Admin/InsightRequests/_components/StatusBadge.tsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import type { BizminerAdminInsightRequestDetail } from "@/types/serializers";

export const StatusTimingCard = ({
  insightRequest,
}: {
  insightRequest: BizminerAdminInsightRequestDetail;
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Clock className="h-5 w-5" />
        Status & Timing
      </CardTitle>
    </CardHeader>
    <CardContent>
      <dl className="space-y-4">
        <DetailItem label="Status">
          <StatusBadge status={insightRequest.status} />
          {insightRequest.in_progress && (
            <span className="ml-2 text-xs text-muted-foreground">
              (in progress)
            </span>
          )}
        </DetailItem>
        <DetailItem label="Engine Status">
          {insightRequest.engine_status ? (
            <span className="font-mono text-xs">
              {insightRequest.engine_status}
            </span>
          ) : (
            <span className="text-muted-foreground">—</span>
          )}
          {insightRequest.failed_at_engine_status && (
            <span className="ml-2 text-xs text-destructive">
              (failed at: {insightRequest.failed_at_engine_status})
            </span>
          )}
        </DetailItem>
        <DetailItem label="Engine Request ID">
          {insightRequest.engine_request_id ? (
            <code className="text-xs bg-muted px-2 py-1 rounded">
              {insightRequest.engine_request_id}
            </code>
          ) : (
            <span className="text-muted-foreground">—</span>
          )}
        </DetailItem>
        <DetailItem label="Credits Transaction">
          {insightRequest.credits_transaction_id ? (
            <code className="text-xs bg-muted px-2 py-1 rounded">
              #{insightRequest.credits_transaction_id}
            </code>
          ) : (
            <span className="text-muted-foreground">—</span>
          )}
        </DetailItem>
      </dl>
    </CardContent>
  </Card>
);
